import { render, staticRenderFns } from "./RfvTable.vue?vue&type=template&id=3a8583d3&scoped=true"
import script from "./RfvTable.vue?vue&type=script&lang=js"
export * from "./RfvTable.vue?vue&type=script&lang=js"
import style0 from "./RfvTable.vue?vue&type=style&index=0&id=3a8583d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8583d3",
  null
  
)

export default component.exports